import AuthConstants from './AuthConsts';
import ToastConstants from '../Toast/ToastConsts';
import { ServerEndpoint } from '../endpoints.ts';
import * as actionLoading from '../Loading/LoadingActions';
import * as actionToast from '../Toast/ToastActions';
import { setAuthToken } from '../../Services/InterceptorService';
import { post, get } from '../../Services/ApiService';
import jwt_decode from 'jwt-decode';
import { User } from '../../Entities/User.ts'

export const login = (user) => async (dispatch) => {
    try {
        dispatch(actionLoading.setLoading('Logging in...'));

        const response = await post(ServerEndpoint.LOGIN, user, true, 'Logging in...');
        const content = response.data;
        console.log(content);
        if (content.status) {
            const emailInitials = content.data.user.email.split('@')[0];
            localStorage.setItem('email', content.data.user.email);
            localStorage.setItem('name', content.data.user.name || emailInitials);
            localStorage.setItem('token', content.data.token);
            setAuthToken(content.data.token);
            dispatch({ type: AuthConstants.LOGIN_SUCCESS, payload: content });
            dispatch(actionToast.setToast('success', `Login Sucsess`));
        }
        else {
            console.log('Login failed');
            dispatch({ type: AuthConstants.LOGIN_FAILURE, payload: content });
            dispatch(actionToast.setToast('error', `login failed`));
        }
    } catch (error) {
        console.log(error);
        dispatch({ type: AuthConstants.LOGIN_FAILURE, payload: {} });
        dispatch(actionToast.setToast('error', `login failed`));
    }
    finally {
        dispatch(actionLoading.disableLoading());
    }
}

export const loginWithGoogle = (user) => async (dispatch) => {
    try {
        dispatch(actionLoading.setLoading('Logging in...'));

        const response = await post(ServerEndpoint.LOGIN_WITH_GOOGLE, user, true, 'Logging in...');
        const content = response.data;
        console.log(content);
        if (content.status) {
            const emailInitials = content.data.user.email.split('@')[0];
            localStorage.setItem('email', content.data.user.email);
            localStorage.setItem('name', content.data.user.name || emailInitials);
            localStorage.setItem('token', content.data.token);
            setAuthToken(content.data.token);
            dispatch({ type: AuthConstants.LOGIN_SUCCESS, payload: content });
            dispatch(actionToast.setToast('success', `Login Sucsess`));
            window.location.reload(true);
        }
        else {
            console.log('Login failed');
            dispatch({ type: AuthConstants.LOGIN_FAILURE, payload: content });
            dispatch(actionToast.setToast('error', `login failed`));
        }
    } catch (error) {
        console.log(error);
        dispatch({ type: AuthConstants.LOGIN_FAILURE, payload: {} });
        dispatch(actionToast.setToast('error', `login failed`));
    }
    finally {
        dispatch(actionLoading.disableLoading());
    }
}

export const isLoggedIn = () => async (dispatch) => {

    try {
        console.log('in isLoggedIn');
        const token = localStorage.getItem('token');
        dispatch(actionLoading.setLoading('Logging in...'));
        if (token) {
            setAuthToken(token);
            const response = await get(ServerEndpoint.LOGIN_CHECK, true, 'Logging in...');
            const content = response.data;
            if (content.status) {
                console.log(content.status + 'authenticatied');
                setAuthToken(token);
                dispatch({ type: AuthConstants.CHECK_LOGIN_SUCCESS, payload: content });
                dispatch(actionToast.setToast('success', `Welcome Back`, 3000));
            }
            else {
                console.log('Login failed');
                dispatch({ type: ToastConstants.SET_TOAST, payload: { type: ToastConstants.SET_TOAST, message: 'test', timeout: 2000 } });
                dispatch(actionToast.setToast('error', `Session Expired`, 3000));
                localStorage.removeItem('token');
            }
        }
    }
    catch (error) {
        console.log(error);
        dispatch({ type: AuthConstants.LOGIN_FAILURE, payload: {} });
        dispatch(actionToast.setToast('error', `Session Expired`, 3000));
        localStorage.removeItem('token');
    }
    finally {
        dispatch(actionLoading.disableLoading());
    }
}


export const handleLoginWithGoogle = (res) => async (dispatch) => {
    try {
        const cerdentials = jwt_decode(res.credential);
        const user = new User(cerdentials.email, '1234');
        dispatch(loginWithGoogle(user));
        dispatch(isLoggedIn());
    }
    catch (error) {
        console.log(error);
    }
}

export const handleSignUpWithGoogle = (res) => async (dispatch) => {
    try {
        const cerdentials = jwt_decode(res.credential);
        const user = new User(cerdentials.email, '1234');
        dispatch(signupWithGoogle(user));
        dispatch(loginWithGoogle(user));
        dispatch(isLoggedIn());
    }
    catch (error) {
        console.log(error);
    }
}

export const signup = (user) => async (dispatch) => {
    try {
        dispatch(actionLoading.setLoading('Signing up...'));

        const response = await post(ServerEndpoint.SIGN_UP, user, true, 'Signing up...');
        const content = response.data;
        console.log(content);
        if (content.status) {
            dispatch({ type: AuthConstants.SIGN_UP_SUCCESS, payload: {} });
            dispatch(actionToast.setToast('success', content.message));
            dispatch(login(user));
            dispatch(isLoggedIn());
        }
        else {
            console.log(content.message);
            dispatch(actionToast.setToast('error', content.message));
        }
    } catch (error) {
        console.log(error);
        dispatch({ type: AuthConstants.LOGIN_FAILURE, payload: {} });
        dispatch(actionToast.setToast('error', `sign-up failed`));
    }
    finally {
        dispatch(actionLoading.disableLoading());
    }
}


export const signupWithGoogle = (user) => async (dispatch) => {
    try {
        dispatch(actionLoading.setLoading('Signing up...'));

        const response = await post(ServerEndpoint.SIGN_UP_WITH_GOOGLE, user, true, 'Signing up...');
        const content = response.data;
        console.log(content);
        if (content.status) {
            dispatch(actionToast.setToast('success', content.message));
            dispatch({ type: AuthConstants.SIGN_UP_SUCCESS, payload: {} });
        }
        else {
            console.log(content.message);
            dispatch(actionToast.setToast('error', content.message));
        }
    } catch (error) {
        console.log(error);
        dispatch({ type: AuthConstants.LOGIN_FAILURE, payload: {} });
        dispatch(actionToast.setToast('error', `sign-up failed`));
    }
    finally {
        dispatch(actionLoading.disableLoading());
    }
}

export const disableSignUp = () => async (dispatch) => {
    dispatch({ type: AuthConstants.SIGN_UP_DISABLE, payload: {} });
}


export const resetPasswrd = (user) => async (dispatch) => {
    try {
        dispatch(actionLoading.setLoading('Sending New Password To Email...'));

        const response = await post(ServerEndpoint.RESET_PASSWORD, user, true, 'Sending New Password To Email...');
        const content = response.data;
        console.log(content);
        if (content.status) {
            dispatch(actionToast.setToast('success', content.message));
            dispatch({ type: AuthConstants.RESET_PASSWORD_SUCCESS, payload: {} });
        }
        else {
            console.log(content.message);
            dispatch({ type: AuthConstants.RESET_PASSWORD_FAILURE, payload: {} });
            dispatch(actionToast.setToast('error', content.message));
        }
    } catch (error) {
        console.log(error);
        dispatch({ type: AuthConstants.RESET_PASSWORD_FAILURE, payload: {} });
        dispatch(actionToast.setToast('error', `sign-up failed`));
    }
    finally {
        dispatch(actionLoading.disableLoading());
    }
}

export const updateUserImage = (file) => async (dispatch) => {
    try {
        dispatch(actionLoading.setLoading('Updating user profile picture...'));

        const response = await post(ServerEndpoint.PROFILE_UPDATE_IMAGE, file, true, 'Updating user profile picture...');
        const content = response.data;
        console.log(content);
        if (content.status) {
            dispatch(actionToast.setToast('success', content.message));
        }
        else {
            dispatch(actionToast.setToast('error', content.message));
        }
    } catch (error) {
        console.log(error);
        dispatch(actionToast.setToast('error', `sign-up failed`));
    }
    finally {
        dispatch(actionLoading.disableLoading());
    }
}

export const logout = () => async (dispatch) => {
    try {
        dispatch(actionLoading.setLoading('Logging Out...'));
        setTimeout(() => {
            dispatch({ type: AuthConstants.LOGOUT });
            setAuthToken();
            localStorage.removeItem('token');
            localStorage.removeItem('email');
            dispatch(actionLoading.disableLoading());
        }, 2000);
    } catch (error) {
        console.log(error);
    }
}


export const redirectScreen = (path) => async (dispatch) => {
    try {
        dispatch({ type: AuthConstants.REDIRECT_SCREEN, payload: { currentRoute: path } });
    } catch (error) {
        console.log(error);
    }
}

export const changeTheme = (theme) => async (dispatch) => {
    try {
        // console.log('Changing theme...', theme);
        dispatch({ type: AuthConstants.CHANGE_THEME, payload: { theme: theme } });
    } catch (error) {
        console.log(error);
    }
}


export const alertExceeded = () => async (dispatch) => {
    try {
        dispatch({ type: AuthConstants.USER_EXCEEDED, payload: {} });
    } catch (error) {
        console.log(error);
    }
}


export const clearAlertExceeded = () => async (dispatch) => {
    try {
        dispatch({ type: AuthConstants.CLEAR_USER_EXCEEDED, payload: {} });
    } catch (error) {
        console.log(error);
    }
}



